import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import Link from '@src/components/link';
import PopMiniModalStore from './store';
import toWebpImage from '@src/utils/to-webp-image';

const styles = require('./index.less');

/**
 * 组队微信小程序二维码弹窗
 */
const PopMiniModal = ({ store, onClose }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={cx(styles.popMiniModalRoot)}>
        <div className={styles.content}>
          <Link className={styles.closeBtn} onClick={store.onClickClose} />
          <img alt="" src={toWebpImage(require('./images/pop-mini.jpg'))} className={styles.qrCodeCover} />
        </div>
      </div>
    </ModalContainer>
  );
};

export default wrapStore(PopMiniModal, PopMiniModalStore);
